/**
 * Government modal — close on overlay click.
 * Migrated from shared/modals.html inline JS.
 */

export function initGovModal(): void {
  const modal = document.getElementById("govModal");
  modal?.addEventListener("click", function (this: HTMLElement, e: Event) {
    if (e.target === this) {
      bootstrap.Modal.getInstance(this)?.hide();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => initGovModal());
